import { Role } from "@enums";
import { useAppSelector } from "@hooks";

export const useCheckUserRole = (role: Role): boolean => {
  const roles: Role[] = useAppSelector((state) => state?.auth?.roles);
  const preferredRole: Role =
    useAppSelector((state) => state?.auth?.preferredRole) ?? Role.RO;

  // If no roles, return false
  if (!roles || roles?.length === 0) return false;

  // If a user has both dosi and ro role, use the preferred role.
  if (
    roles.includes(Role.DOSIMETRIST) &&
    roles.includes(Role.RO) &&
    [Role.RO, Role.DOSIMETRIST].includes(role)
  ) {
    return preferredRole === role;
  }
  return roles.includes(role);
};
